import React from 'react';
import { Link } from 'react-router-dom';

const JLPTCourse = () => {
    const cardStyle = {
        background: '#fff',
        padding: '25px',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        marginBottom: '20px'
    };

    const imgCourse1 = `${process.env.PUBLIC_URL}/jlpt-1.jpg`;
    const imgCourse2 = `${process.env.PUBLIC_URL}/jlpt-career-path.jpg`;

    return (
        <div style={{ fontFamily: 'Arial, sans-serif' }}>

            {/* Header Image Banner - Margin aur Object Position Fix kiya */}
            <div style={{ width: '100%', overflow: 'hidden', marginTop: '0' }}>
                <img
                    src={imgCourse1}
                    alt="JLPT Course Banner"
                    style={{
                        width: '100%',
                        maxHeight: '450px',
                        objectFit: 'cover',
                        objectPosition: 'center top', // Image ko top se align rakhega
                        display: 'block'
                    }}
                    onError={(e) => { e.target.style.display = 'none'; console.error("Banner load failed"); }}
                />
            </div>

            {/* Main Content Container */}
            <div style={{ maxWidth: '900px', margin: '20px auto', padding: '0 20px' }}>

                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                    <h1 style={{ color: '#d32f2f' }}>JLPT Course: Pathway to Career in Japan & India</h1>
                    <p style={{ fontSize: '1.1rem' }}><strong>Location:</strong> R.B. (P.G.) College, Agra | <strong>Mode:</strong> Online & Offline Both</p>
                </div>

                {/* Overview */}
                <div style={cardStyle}>
                    <h2>JLPT Levels Overview</h2>
                    <p>The JLPT certification consists of 5 levels (from N5 to N1), with N3 and N2 being the most significant levels for job opportunities.[cite: 1].</p>
                </div>

                {/* Career Path */}
                <div style={cardStyle}>
                    <h3>Career Path & Opportunities</h3>
                    <img
                        src={imgCourse2}
                        alt="Career Path Diagram"
                        style={{ width: '100%', borderRadius: '8px', marginBottom: '15px', display: 'block' }}
                        onError={(e) => { e.target.style.display = 'none'; }}
                    />

                </div>

                {/* Course Progression */}
                <div style={cardStyle}>
                    <h3>Course Progression</h3>
                    <p><strong>N5 (Beginner):</strong> Hiragana, Katakana, 100 Kanji[cite: 1].</p>
                    <p><strong>N4 (Elementary):</strong> 300 Kanji, daily communication[cite: 1].</p>
                    <p><strong>N3 (Intermediate):</strong> 650 Kanji, Business email basics[cite: 1].</p>
                    <p><strong>N2 (Professional):</strong> 1000+ Kanji, Corporate communication[cite: 1].</p>
                    <p><strong>N1 (Advanced):</strong> Native-level interpretation, legal terms[cite: 1].</p>
                </div>

                {/* CTA Section */}
                <div style={{ backgroundColor: '#f44336', padding: '30px', borderRadius: '10px', color: '#fff', textAlign: 'center', marginBottom: '50px' }}>
                    <h2>Start Your JLPT Journey Today!</h2>
                    <p>You can join our courses at R.B. (P.G.) College, Agra, in both online and offline modes..</p>
                    <Link to="/enquiry">
                        <button style={{ padding: '12px 25px', background: '#fff', color: '#d32f2f', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '1rem', fontWeight: 'bold' }}>
                            ENROLL NOW →
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default JLPTCourse;